// @ts-nocheck
import { Box, Button, StackRow, Text } from "@smoothie-framework/ui";

const HEADER_IDLE_DELAY = 640;
let disposeHeaderScroll: (() => void) | undefined;

export function initializeHeaderScroll() {
  disposeHeaderScroll?.();

  if (typeof window === "undefined") {
    return;
  }

  const header = document.querySelector<HTMLElement>(".site-header");
  const hero = document.querySelector<HTMLElement>("#top");

  if (!header || !hero) {
    return;
  }

  let animationFrame = 0;
  let idleTimer: number | undefined;
  let previousScrollY = window.scrollY;

  const updateHeader = () => {
    const currentScrollY = window.scrollY;
    const scrollDelta = currentScrollY - previousScrollY;
    const isPastHero = currentScrollY >= hero.offsetHeight;

    header.classList.toggle("site-header--solid", isPastHero);

    if (currentScrollY <= 8 || scrollDelta < -4) {
      header.classList.remove("site-header--hidden");
    } else if (scrollDelta > 4) {
      header.classList.add("site-header--hidden");
    }

    window.clearTimeout(idleTimer);
    idleTimer = window.setTimeout(() => {
      header.classList.remove("site-header--hidden");
    }, HEADER_IDLE_DELAY);

    previousScrollY = currentScrollY;
  };

  const scheduleUpdate = () => {
    window.cancelAnimationFrame(animationFrame);
    animationFrame = window.requestAnimationFrame(updateHeader);
  };

  window.addEventListener("scroll", scheduleUpdate, { passive: true });
  scheduleUpdate();

  disposeHeaderScroll = () => {
    window.cancelAnimationFrame(animationFrame);
    window.clearTimeout(idleTimer);
    window.removeEventListener("scroll", scheduleUpdate);
  };
}

export function Header() {
  return (
    <Box as="header" className="site-header" h={{ base: 17, lg: 22 }} w="full">
      <StackRow
        align="center"
        className="site-header-content"
        h="full"
        justify="between"
        w="full"
        maxW={360}
        mx="auto"
        px={{ base: 6, md: 16 }}
      >
        <StackRow asChild align="center" gap={3}>
          <a className="brand" href="#top" aria-label="Zequels home">
            <Text
              as="span"
              className="brand-wordmark"
              textStyle="brand-navigation"
            >
              ZEQUELS
            </Text>
            <Box
              as="span"
              background="surface2"
              className="brand-divider"
              h={5.5}
              w={0.25}
            />
            <Text
              as="span"
              className="brand-product"
              textStyle="label"
              color="subtle"
            >
              AI Micro-Drama Studio
            </Text>
          </a>
        </StackRow>
        <StackRow className="header-actions" gap={2} align="center">
          <Text
            as="span"
            className="beta-note"
            mr={2}
            textStyle="label"
            color="subtle"
          >
            Private Beta <span aria-hidden="true">•</span> Invite Only
          </Text>
          <Button asChild variant="primary" size="md">
            <a href="#request">Request access</a>
          </Button>
        </StackRow>
      </StackRow>
    </Box>
  );
}
